module.exports = __webpack_public_path__ + "static/magento_logo-2e23ab0b5853cb8feb40eff4f30845fa.svg";